import { render, staticRenderFns } from "./hotel-edit.vue?vue&type=template&id=4a8547b5&scoped=true"
import script from "./hotel-edit.vue?vue&type=script&lang=js"
export * from "./hotel-edit.vue?vue&type=script&lang=js"
import style0 from "./hotel-edit.vue?vue&type=style&index=0&id=4a8547b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8547b5",
  null
  
)

export default component.exports